import type { MonthlyCalculatorFormValues } from "../types/form"

/**
 * Returns the default values for a new monthly calculator form.
 * Uses the same distributions as weekly (typical call center patterns).
 * Default incoming contacts is 400 per month.
 */
export function getDefaultMonthlyFormValues(): MonthlyCalculatorFormValues {
  return {
    // Monthly contacts default (will be converted to weekly by backend)
    incomingContacts: "400",
    averageHandleTimeSeconds: "257",
    requiredServiceLevel: "80",
    targetAnswerTimeSeconds: "20",
    shrinkage: "30",
    maxOccupancy: "85",
    averagePatienceSeconds: "60",
    workingHoursPerWeek: "37.5",
    reportingInterval: "30min",

    // Weekly-specific fields (same structure as weekly)
    hoursOpenPerDay: "9",
    weekStart: "monday",
    distributionMonday: "23.8",
    distributionTuesday: "21.6",
    distributionWednesday: "19.5",
    distributionThursday: "18.6",
    distributionFriday: "16.5",
    distributionSaturday: "0",
    distributionSunday: "0",
  }
}

// Re-export utilities from weekly
export { calculateDistributionTotal, isDistributionValid } from "@/features/weekly/utils/form"
